import React from "react";

interface SubmitPopupProps {
  onClose: () => void;
}

export default function SubmitPopup({ onClose }: SubmitPopupProps) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 bg-opacity-50 z-50">
      <div className="bg-white p-8 rounded-lg text-black mx-4 flex flex-col items-center gap-3">
        <p className="text-3xl">🎉</p>
        <h2 className="text-2xl font-bold">
          Message Received!
        </h2>
        <p className=" max-w-[20rem] text-center text-muted-2-foreground">Thank you for reaching out. Our Team will get back to you shortly.</p>
        <button
          className=" bg-primary text-white px-6 w-full py-2 rounded-md cursor-pointer"
          onClick={onClose}
        >
          Got it
        </button>
      </div>
    </div>
  );
}
